import {
  rightPaneContentAtom,
  rightPaneEnabledAtom,
  rightPaneExpandedAtom,
  rightPaneTitleAtom,
} from '@/components/right-pane/right-pane.state';
import { SelectionsSidebar } from '@/features/trends/components/selections-sidebar/selections-sidebar';
import { currentChartIdAtom } from '@/features/trends/state/current-chart.state';
import { firstChartIdAtom } from '@/features/trends/state/trend-groups.state';
import { jotaiStore } from '@/providers/jotai/jotai-store';
import UserStateAtoms from '@/state/user.state';
import { resolveFacilityFromParams } from '@/utils/facility-resolver';

type TrendsRouteParams = { org: string; agent: string };

export const trendsRouteBeforeLoad = () => {
  jotaiStore.set(rightPaneEnabledAtom, true);
  jotaiStore.set(rightPaneExpandedAtom, true);
  jotaiStore.set(rightPaneContentAtom, <SelectionsSidebar />);
  jotaiStore.set(rightPaneTitleAtom, 'Trends Data');
};

export const trendsRouteLoader = ({ params }: { params: TrendsRouteParams }) => {
  const userState = jotaiStore.get(UserStateAtoms.user);
  const { agentId } = resolveFacilityFromParams(params, userState);

  const firstChartId = jotaiStore.get(firstChartIdAtom);
  if (firstChartId) {
    jotaiStore.set(currentChartIdAtom, firstChartId);
  }

  return { agentId };
};
